import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Popover, Typography } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import XLSX from "utils/xlsxStyled";
import eOpsLogo from "../../../images/eops.png";
import excel from "../../../images/excel.png";
import mepcoLogo from "../../../images/mepcoLogo.png";
import pdf from "../../../images/pdf.png";
import print from "../../../images/print.png";
import { cfpBaseUrl } from "../../../network/urls";
import {
  convertDate,
  convertDatewithTime,
  printStamp,
  subdivisionName,
  getName,
  getShortMonthName,
  companyShortName,
  getCompanyName,
  companyName,
  getLogo,
} from "../../../services/Functions";
import { internalIconStyles } from "../../../style/common";
import "../../../style/common.scss";
import { Code } from "lucide-react";

const LinemanAPPUserSummary = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const {
    token,
    code,
    name,
    roleName,
    roleTypeName,
    cscID,
    cfcLevelId,
    roleId,
    hierarchy: hierar,
  } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = React.useState(false);
  // const { officeCode: offCode } = useSelector(state => state.officeCode);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  const [totals, setTotals] = useState({});
  const [dateFrom, setDateFrom] = useState(getCurrentDate());
  const [dateTo, setDateTo] = useState(getCurrentDate());
  const tableRef = useRef(null);
  const [dateFromDisplay, setDateFromDisplay] = useState("");
  const [dateToDisplay, setDateToDisplay] = useState("");
  const [category, setCategory] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [hierarchy, setHierarchy] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRemarks, setSelectedRemarks] = useState("");
  const [selectedPerson, setSelectedPerson] = useState("");
  const [lastModifiedByOptions, setLastModifiedByOptions] = useState([]);
  const [selectedPerson1, setSelectedPerson1] = useState("");
  const [registeredByOptions, setRegisteredByOptions] = useState([]);
  const [desginationCodeToApi, setDesginationCodeToApi] = useState("1135");
  const [desginationList, setDesginationList] = useState([]);
  const [companyCode, setCompanyCode] = useState("15");
  const [complaintPart, setComplaintPart] = useState("2");
  const [sourceWise, setSourceWise] = useState("2");
  const [shiftWise, setShiftWise] = useState("1");
  const [filteredDesignationList, setFilteredDesignationList] = useState([]);
  const [desginationName, setDesginationName] = useState("TAC");
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const offCode =
    hierar == 1
      ? code
      : hierar == 2
      ? code.slice(0, 2)
      : hierar == 3
      ? code.slice(0, 3)
      : hierar == 4
      ? code.slice(0, 4)
      : hierar == 5
      ? code.slice(0, 5)
      : code;
  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  useEffect(() => {
    setOfficeCode(circleCode);
  }, [circleCode]);

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              console.error("Error fetching subDivisions:", result.message);
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching subDivisions:", error);
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(offCode == 10 ? 15 : offCode);
          let officeName = getName(
            offCode == 10 ? "15" : offCode.toString(),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(offCode == 10 ? 15 : offCode);
        let offName = getName(
          offCode == 10 ? "15" : offCode.toString(),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        console.log("1 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        console.log("2 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        console.log("3 wala if");
        setCircleCode(offCode.slice(0, 3));
        console.log(offCode.slice(0, 3), "djlsahjdhalhdalhlkd");
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        console.log("4 wala if");
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const getStats = async (
    officeCode,
    roleId,
    sourceWise,
    shiftWise,
    complaintPart
  ) => {
    // const effectiveOfficeCode = selectedSubDivision || selectedDivision || circleCode || selectedCompanyCode || code.slice(0, 2);
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        officeCode: officeCode,
        roleId: roleId || "1135",
        isLoggedInFromMobile: sourceWise,
        shiftId: shiftWise,
        roleTypeId: complaintPart,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl + "workForce/getUserLoggedStatus",
        requestOptions
      );
      const result = await response.json();

      if (result.status == "200") {
        const data = result.data;

        const groupedData = {};

        data.forEach((user) => {
          const key = user.subDivisionCode;
          if (!groupedData[key]) {
            groupedData[key] = {
              circleCode: user.circleCode,
              circleName: user.circleName,
              divisionName: user.divisionName,
              subDivisionName: user.subDivisionName,
              roleName: user.role_id,
              sdivSet: new Set(),
              LoggedInLineStaff: 0,
              NeverLoggedInLineStaff: 0,
              totalLineStaff: 0,
            };
          }

          const group = groupedData[key];
          group.totalLineStaff += 1;
          if (user.isLogged_In) {
            group.LoggedInLineStaff += 1;
          } else {
            group.NeverLoggedInLineStaff += 1;
          }

          group.sdivSet.add(user.sdivCode);
        });

        const tableDataArray = Object.values(groupedData).map((group) => ({
          ...group,
          sdivCount: group.sdivSet.size,
        }));

        // 🔹 Check how many unique circles exist
        const uniqueCircles = [
          ...new Set(tableDataArray.map((item) => item.circleCode)),
        ];

        let finalData = [];

        if (uniqueCircles.length > 1) {
          // ✅ Case 1: Multiple circles → total by circle
          const circleTotals = {};
          tableDataArray.forEach((item) => {
            const circleKey = item.circleCode;
            if (!circleTotals[circleKey]) {
              circleTotals[circleKey] = {
                circleCode: circleKey,
                circleName: item.circleName,
                divisionName: "-",
                subDivisionName: "-",
                roleName: item.roleName,
                sdivCount: 0,
                LoggedInLineStaff: 0,
                NeverLoggedInLineStaff: 0,
                totalLineStaff: 0,
              };
            }
            circleTotals[circleKey].sdivCount += item.sdivCount;
            circleTotals[circleKey].LoggedInLineStaff += item.LoggedInLineStaff;
            circleTotals[circleKey].NeverLoggedInLineStaff +=
              item.NeverLoggedInLineStaff;
            circleTotals[circleKey].totalLineStaff += item.totalLineStaff;
          });

          const groupedByCircle = tableDataArray.reduce((acc, item) => {
            if (!acc[item.circleCode]) acc[item.circleCode] = [];
            acc[item.circleCode].push(item);
            return acc;
          }, {});

          Object.keys(groupedByCircle).forEach((circleCode) => {
            finalData.push(...groupedByCircle[circleCode]);
            finalData.push({ ...circleTotals[circleCode], isTotalRow: true });
          });
        } else {
          // ✅ Case 2: Only one circle → total by divisionName
          const divisionTotals = {};
          tableDataArray.forEach((item) => {
            const divKey = item.divisionName;
            if (!divisionTotals[divKey]) {
              divisionTotals[divKey] = {
                circleCode: item.circleCode,
                circleName: item.circleName,
                divisionName: divKey,
                subDivisionName: "-",
                roleName: item.roleName,
                sdivCount: 0,
                LoggedInLineStaff: 0,
                NeverLoggedInLineStaff: 0,
                totalLineStaff: 0,
              };
            }
            divisionTotals[divKey].sdivCount += item.sdivCount;
            divisionTotals[divKey].LoggedInLineStaff += item.LoggedInLineStaff;
            divisionTotals[divKey].NeverLoggedInLineStaff +=
              item.NeverLoggedInLineStaff;
            divisionTotals[divKey].totalLineStaff += item.totalLineStaff;
          });

          const groupedByDivision = tableDataArray.reduce((acc, item) => {
            if (!acc[item.divisionName]) acc[item.divisionName] = [];
            acc[item.divisionName].push(item);
            return acc;
          }, {});

          Object.keys(groupedByDivision).forEach((divName) => {
            finalData.push(...groupedByDivision[divName]);
            finalData.push({ ...divisionTotals[divName], isTotalRow: true });
          });
        }

        console.log(finalData, "finalData with correct totals");
        setTableData(finalData);
      } else if (result.status == "400") {
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
      setTableData([]);
    }

    setViewBackdrop(false);
  };

  const exportToExcel = () => {
    let offName = officeName || "MEPCO Region";
    let dateToPrint = convertDate(new Date());

    const formattedDateFrom = dateFrom ? convertDate(dateFrom) : "-";
    const formattedDateTo = dateTo ? convertDate(dateTo) : "-";
    const headingText = `Active User Summary for ${companyShortName(
      code.slice(0, 2)
    )} of ${
      getDateDifference(dateFrom, dateTo) > 0
        ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
        : formatDate(dateFrom)
    }`;

    const wb = XLSX.utils.book_new();
    const wsData = [];

    wsData.push([headingText]);
    wsData.push([
      "Circle Code",
      "Circle Name",
      "Division Name",
      "Sub-Division Name",
      "Role Name",
      "LoggedIn User",
      "LoggedOut User",
      "Total User",
    ]);

    if (tableData && tableData.length > 0) {
      tableData.forEach((item) => {
        const role = desginationList.find(
          (designation) => designation.employeeDesignationId === item.roleName
        );
        wsData.push([
          item.circleCode || "-",
          item.circleName || "-",
          item.divisionName || "-",
          item.subDivisionName || "-",
          role?.employeeDesignationName || "-",
          item.LoggedInLineStaff || "-",
          item.NeverLoggedInLineStaff || "-",
          item.totalLineStaff || "-",
        ]);
      });

      const totalLoggedIn = tableData.reduce(
        (sum, item) => sum + (item.LoggedInLineStaff || 0),
        0
      );
      const totalNeverLoggedIn = tableData.reduce(
        (sum, item) => sum + (item.NeverLoggedInLineStaff || 0),
        0
      );
      const totalLineStaff = tableData.reduce(
        (sum, item) => sum + (item.totalLineStaff || 0),
        0
      );
      wsData.push([
        "Total",
        "",
        "",
        "",
        "",
        totalLoggedIn || "-",
        totalNeverLoggedIn || "-",
        totalLineStaff || "-",
      ]);
    } else {
      wsData.push(["No Data Found"]);
    }

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];
    if (!ws["A1"]) ws["A1"] = {};
    ws["A1"].s = {
      alignment: { horizontal: "center", vertical: "center" },
      font: { bold: true },
    };

    [
      "Circle Code",
      "Circle Name",
      "Division Name",
      "Sub-Division Name",
      "Role Name",
      "LoggedIn User",
      "LoggedOut User",
      "Total User",
    ].forEach((_, index) => {
      const cell = XLSX.utils.encode_cell({ r: 1, c: index });
      if (!ws[cell]) ws[cell] = {};
      ws[cell].s = { font: { bold: true }, alignment: { horizontal: "left" } };
    });

    if (tableData && tableData.length > 0) {
      const totalRowIndex = tableData.length + 2;
      [
        "Circle Code",
        "Circle Name",
        "Division Name",
        "Sub-Division Name",
        "Role Name",
        "LoggedIn User",
        "LoggedOut User",
        "Total User",
      ].forEach((_, index) => {
        const cell = XLSX.utils.encode_cell({ r: totalRowIndex, c: index });
        if (!ws[cell]) ws[cell] = {};
        ws[cell].s = {
          font: { bold: true },
          fill: { fgColor: { rgb: "FEF5C0" } },
          alignment: { horizontal: "left" },
        };
      });
    }

    ws["!cols"] = [
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 25 },
      { wch: 20 },
      { wch: 15 },
      { wch: 20 },
      { wch: 15 },
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const fileName = `${companyShortName(code.slice(0, 2))} - ${
      getDateDifference(dateFrom, dateTo) > 0
        ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
        : formatDate(dateFrom)
    } - lineman-app-usage-summary.xlsx`;

    saveAs(new Blob([wbout]), fileName);
  };

  const connectionTypes = [
    "Circle Code",
    "Circle Name",
    "Division Name",
    "Sub-Division Name",
    "Role Name",
    "LoggedIn User",
    "LoggedOut User",
    "Total User",
  ];

  const connectionTypesExcel = [
    "Circle Code",
    "Circle Name",
    "Division Name",
    "Sub-Division Name",
    "Role Name",
    "LoggedIn User",
    "LoggedOut User",
    "Total User",
  ];

  const [categoryName, setcategoryName] = useState("New Connections");

  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = subdivisionName(parseInt(code), subDivisions);
      let dateToPrint = convertDate(new Date());
      let stampData = printStamp(code, offName, name, roleName, dateToPrint);
      const title = `Active User Summary for ${offName} of ${
        getDateDifference(dateFrom, dateTo) > 0
          ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
          : formatDate(dateFrom)
      }`;

      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth = ["12", "13", "11", "16", "27", "48", "59"].includes(
        companyCode
      )
        ? 25
        : 30;
      const logoHeight = ["12", "13", "11", "16", "27", "48", "59"].includes(
        companyCode
      )
        ? 20
        : 10;
      pdf.addImage(
        getLogo(code.slice(0, 2)),
        "PNG",
        15,
        5,
        logoWidth,
        logoHeight
      );

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition = [
        "12",
        "13",
        "11",
        "16",
        "27",
        "48",
        "59",
      ].includes(companyCode)
        ? 43
        : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        ["12", "13", "11", "16", "27", "48", "59"].includes(companyCode)
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );

      pdf.setFontSize(12);
      pdf.text(companyName(code.slice(0, 2)), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(
        `Active User Summary for ${companyShortName(code.slice(0, 2))}`,
        pageWidth / 2,
        18,
        { align: "center" }
      );
      pdf.setFontSize(10);
      pdf.text(title, pageWidth / 2, 25, { align: "center" });
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      const headers = [
        { content: "Circle Code", styles: { halign: "left" } },
        { content: "Circle Name", styles: { halign: "left" } },
        { content: "Division Name", styles: { halign: "left" } },
        { content: "Sub-Division Name", styles: { halign: "left" } },
        { content: "Role Name", styles: { halign: "left" } },
        { content: "LoggedIn User", styles: { halign: "left" } },
        { content: "LoggedOut User", styles: { halign: "left" } },
        { content: "Total User", styles: { halign: "left" } },
      ];

      let bodyData = [];

      if (tableData && tableData.length > 0) {
        // 🔹 Map table rows
        bodyData = tableData.map((item) => {
          const role = desginationList.find(
            (designation) => designation.employeeDesignationId === item.roleName
          );

          return [
            { content: item.circleCode || "-", styles: { halign: "left" } },
            { content: item.circleName || "-", styles: { halign: "left" } },
            { content: item.divisionName || "-", styles: { halign: "left" } },
            {
              content: item.subDivisionName || "-",
              styles: { halign: "left" },
            },
            {
              content:
                role?.employeeDesignationName ||
                (item.isTotalRow ? "TOTAL" : "-"),
              styles: { halign: "left" },
            },
            {
              content: item.LoggedInLineStaff || 0,
              styles: { halign: "left" },
            },
            {
              content: item.NeverLoggedInLineStaff || 0,
              styles: { halign: "left" },
            },
            { content: item.totalLineStaff || 0, styles: { halign: "left" } },
          ].map((cell) => {
            // 🔹 Style total rows differently
            if (item.isTotalRow) {
              return {
                ...cell,
                styles: {
                  ...cell.styles,
                  fontStyle: "bold",
                  fillColor: [233, 247, 239], // light green
                },
              };
            }
            return cell;
          });
        });

        // 🔹 Grand Total (only from isTotalRow)
        const totalRows = tableData.filter((item) => item.isTotalRow);

        const totalLoggedIn = totalRows.reduce(
          (sum, item) => sum + (item.LoggedInLineStaff || 0),
          0
        );
        const totalNeverLoggedIn = totalRows.reduce(
          (sum, item) => sum + (item.NeverLoggedInLineStaff || 0),
          0
        );
        const totalLineStaff = totalRows.reduce(
          (sum, item) => sum + (item.totalLineStaff || 0),
          0
        );

        // 🔹 Collect unique role names
        const uniqueRoles = [
          ...new Set(
            totalRows.map((item) => {
              const role = desginationList.find(
                (designation) =>
                  designation.employeeDesignationId === item.roleName
              );
              return role?.employeeDesignationName || "-";
            })
          ),
        ].join(", ");

        bodyData.push([
          {
            content: "Grand Total",
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: "-",
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: "-",
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: "-",
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: uniqueRoles,
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: totalLoggedIn.toString(),
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: totalNeverLoggedIn.toString(),
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: totalLineStaff.toString(),
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
        ]);
      } else {
        bodyData.push([
          {
            content: "No Data Found",
            colSpan: headers.length,
            styles: {
              halign: "center",
              fontSize: 12,
              fontStyle: "bold",
              fillColor: [255, 255, 255],
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: bodyData,
        styles: {
          cellPadding: 3,
          fontSize: 8,
          halign: "left",
        },
        theme: "striped",
        tableWidth: pageWidth - 30,
        margin: { left: 15, right: 15 },
        columnStyles: {
          0: { cellWidth: 20 },
          1: { cellWidth: 50 },
          2: { cellWidth: 40 },
          3: { cellWidth: 50 },
          4: { cellWidth: 23 },
          5: { cellWidth: 31 },
          6: { cellWidth: 31 },
          7: { cellWidth: 20 },
        },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      const filename = `${companyShortName(code.slice(0, 2))} - ${
        getDateDifference(dateFrom, dateTo) > 0
          ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
          : formatDate(dateFrom)
      } - lineman-app-usage-summary.pdf`;

      if (print) {
        pdf.save(filename);
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };

  // useEffect(() => {
  //   const getDesgination = async () => {
  //     setViewBackdrop(true);
  //     const myHeaders = new Headers();
  //     myHeaders.append("Authorization", token);
  //     const raw = "";
  //     const requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: raw,
  //       redirect: "follow"
  //     };
  //     fetch(cfpBaseUrl + "workForce/getListOfSubDivisionDesignations", requestOptions)
  //       .then((response) => response.json())
  //       .then((result) => {
  //         setViewBackdrop(false);
  //         if (result.message == 'Data Found.') {
  //           setDesginationList(result.data);
  //         }
  //       })
  //       .catch((error) => console.error(error));
  //   };
  //   getDesgination();
  // }, [companyCode]);

  useEffect(() => {
    const getDesgination = async () => {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: "",
        redirect: "follow",
      };
      try {
        const response = await fetch(
          cfpBaseUrl + "workForce/getListOfSubDivisionDesignations",
          requestOptions
        );
        const result = await response.json();
        setViewBackdrop(false);
        if (result.message === "Data Found.") {
          setDesginationList(result.data || []);
          const filtered = (result.data || []).filter((item) => {
            if (complaintPart === "1") {
              return ["94", "95", "96", "113", "114", "1114", "1131"].includes(
                item.employeeDesignationId.toString()
              );
            } else if (complaintPart === "2") {
              return ["95", "113", "1135", "1145", "1146", "1147"].includes(
                item.employeeDesignationId.toString()
              );
            }
            return true;
          });
          setFilteredDesignationList(filtered);
          setDesginationCodeToApi(complaintPart === "1" ? "113" : "1135");
        } else {
          setDesginationList([]);
          setFilteredDesignationList([]);
        }
      } catch (error) {
        console.error("Error fetching designations:", error);
        setDesginationList([]);
        setFilteredDesignationList([]);
        setViewBackdrop(false);
      }
    };
    getDesgination();
  }, [token, complaintPart]);

  const getDateDifference = (startDate, endDate) => {
    const startDates = startDate.split(",")[0];
    const endDates = endDate.split(",")[0];
    const start = new Date(startDates);
    const end = new Date(endDates);
    const differenceInTime = end - start;
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return differenceInDays;
  };

  const handleRemarksClick = (event, remarks) => {
    if (remarks && remarks.trim() !== "") {
      setAnchorEl(event.currentTarget);
      setSelectedRemarks(remarks);
    }
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const handleChangeDesgination = (e) => {
    console.log(e.target.value, "e.target.value");
    const selectedId = e.target.value;

    setDesginationCodeToApi(selectedId);
    const selectedObj = desginationList.find(
      (item) => item.employeeDesignationId.toString() === selectedId
    );
    if (selectedObj) {
      setDesginationName(selectedObj.employeeDesignationName); // <-- store name only
    }
  };
  const handlePart = (e) => {
    const selectedPart = e.target.value;
    setComplaintPart(selectedPart);
    if (selectedPart === "1") {
      const filtered = desginationList.filter(
        (item) => item.employeeDesignationId.toString() === "1135"
      );
      setFilteredDesignationList(filtered);
      setDesginationCodeToApi("1135");
    } else {
      setFilteredDesignationList(desginationList);
      setDesginationCodeToApi(
        desginationList[0]?.employeeDesignationId || "1135"
      );
    }
  };

  const handleSourceWise = (e) => {
    setSourceWise(e.target.value);
  };

  const handleShiftWise = (e) => {
    setShiftWise(e.target.value);
  };

  const currentFilters = {
    officeCode,
    desginationCodeToApi,
    sourceWise,
    shiftWise,
    complaintPart,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [officeCode, desginationCodeToApi, sourceWise, shiftWise, complaintPart]);

  const handleGoClick = () => {
    getStats(
      officeCode,
      desginationCodeToApi,
      sourceWise,
      shiftWise,
      complaintPart
    );

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  return (
    <>
      <Box className="form-box">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Box className="application-table" style={{ marginRight: "10px" }}>
            <h3 style={{ color: "#006ad1", marginBottom: "10px" }}>
              Active User Summary
            </h3>
            <div className="div-datagrid">
              <div className="reports-container">
                <div
                  className="filter-fields"
                  style={{
                    width: "75%",
                    justifyContent: "flex-start",
                    gap: "15px",
                  }}
                >
                  {code == 10 && (
                    <div className="field-container">
                      <Typography className="field-label">Company</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedCompanyCode}
                        onChange={(e) => {
                          handleChangeCompany(e);
                        }}
                      >
                        <option value="10">Select Company</option>
                        <option value="11">LESCO</option>
                        <option value="12">GEPCO</option>
                        <option value="13">FESCO</option>
                        <option value="14">IESCO</option>
                        <option value="15">MEPCO</option>
                        <option value="26">PESCO</option>
                        <option value="27">HAZECO</option>
                        <option value="37">HESCO</option>
                        <option value="38">SEPCO</option>
                        <option value="48">QESCO</option>
                        <option value="59">TESCO</option>
                      </select>
                    </div>
                  )}

                  {hierarchy <= 2 && (
                    <div className="field-container">
                      <Typography className="field-label">Circle</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={circleCode || ""}
                        onChange={(e) => {
                          handleCircleChange(e);
                        }}
                      >
                        <option value="">All Circle</option>
                        {filteredCircles.map((circle) => (
                          <option
                            key={circle.circleCode}
                            value={circle.circleCode}
                          >
                            {circle.circleName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 3 && (
                    <div className="field-container">
                      <Typography className="field-label">Division</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedDivision || ""}
                        onChange={(e) => {
                          handleDivisionChange(e);
                        }}
                        disabled={!circleCode}
                      >
                        <option value="">All Division</option>
                        {filteredDivisions.map((division) => (
                          <option
                            key={division.divisionCode}
                            value={division.divisionCode}
                          >
                            {division.divisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 4 && (
                    <div className="field-container">
                      <Typography className="field-label">
                        Sub-Division
                      </Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedSubDivision || ""}
                        onChange={(e) => {
                          handleSubDivisionChange(e);
                        }}
                        disabled={!selectedDivision}
                      >
                        <option value="">All Sub-Division</option>
                        {filteredSubDivisions.map((subDivision) => (
                          <option
                            key={subDivision.subDivisionCode}
                            value={subDivision.subDivisionCode}
                          >
                            {subDivision.subDivisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className="field-container">
                    <Typography className="field-label">Part</Typography>
                    <select
                      className="dropdown-field"
                      style={{
                        backgroundColor: "white",
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        padding: "5px 10px",
                        width: "150px",
                      }}
                      value={complaintPart}
                      onChange={(e) => {
                        handlePart(e);
                      }}
                    >
                      <option value="1">Commercial</option>
                      <option value="2">Technical</option>
                    </select>
                  </div>
                  <div className="field-container">
                    <Typography className="field-label">Designation</Typography>
                    <select
                      className="dropdown-field"
                      style={{
                        backgroundColor: "white",
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        padding: "5px 10px",
                        width: "150px",
                      }}
                      value={desginationCodeToApi}
                      onChange={(e) => {
                        handleChangeDesgination(e);
                      }}
                      disabled={!filteredDesignationList.length}
                    >
                      {filteredDesignationList.map((item, index) => (
                        <option key={index} value={item.employeeDesignationId}>
                          {item.employeeDesignationName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="field-container">
                    <Typography className="field-label">Source</Typography>
                    <select
                      className="dropdown-field"
                      style={{
                        backgroundColor: "white",
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        padding: "5px 10px",
                        width: "150px",
                      }}
                      value={sourceWise}
                      onChange={(e) => {
                        handleSourceWise(e);
                      }}
                    >
                      <option value="2">Both</option>
                      <option value="0">Web</option>
                      <option value="1">Mobile</option>
                    </select>
                  </div>
                  <div className="field-container">
                    <Typography className="field-label">Shift</Typography>
                    <select
                      className="dropdown-field"
                      style={{
                        backgroundColor: "white",
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        padding: "5px 10px",
                        width: "150px",
                      }}
                      value={shiftWise}
                      onChange={(e) => {
                        handleShiftWise(e);
                      }}
                    >
                      <option value="1">Morning</option>
                      <option value="2">Evening</option>
                      <option value="3">Night</option>
                      <option value="4">Feeder Wise</option>
                    </select>
                  </div>

                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginTop: "10px" }}
                    onClick={handleGoClick}
                    disabled={isGoDisabled || viewBackdrop}
                  >
                    Go
                  </Button>
                </div>
                <div className="export-button-container">
                    <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>
                </div>
              </div>
              <div className="table-container" style={{ marginBottom: "40px" }}>
                <div id="pdf-table">
                  <div style={{ maxHeight: "900px", overflowY: "auto" }}>
                    <table
                      className="table"
                      ref={tableRef}
                      style={{
                        marginBottom: "40px",
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "white",
                          zIndex: 10,
                        }}
                      >
                        <tr
                          style={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                            zIndex: 3,
                          }}
                        >
                          <th
                            colSpan="14"
                            style={{
                              fontSize: "20px",
                              borderBottom: "2px solid white",
                              textAlign: "center",
                              backgroundColor: "#d5e5ff",
                              color: "black",
                            }}
                          >
                            Active User Summary for {officeName} of{" "}
                            {getDateDifference(dateFrom, dateTo) > 0
                              ? formatDate(dateFrom) +
                                " to " +
                                formatDate(dateTo)
                              : formatDate(dateFrom)}
                          </th>
                        </tr>
                        <tr
                          style={{
                            position: "sticky",
                            top: "37px",
                            backgroundColor: "white",
                            zIndex: 1,
                          }}
                        >
                          {connectionTypes.map((type, index) => (
                            <th
                              key={index}
                              style={{
                                width: `${100 / connectionTypes.length}%`,
                                textAlign: "left",
                                border: "5px solid white",
                                backgroundColor: "#eeeff1",
                                color: "black",
                                fontSize: "14px",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                              }}
                            >
                              {type}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.length > 0 ? (
                          <>
                            {tableData.map((item, id) => {
                              const role = desginationList.find(
                                (designation) =>
                                  designation.employeeDesignationId ===
                                  item.roleName
                              );

                              return (
                                <tr
                                  key={id}
                                  style={{
                                    backgroundColor: item.isTotalRow
                                      ? "#e9f7ef"
                                      : "white",
                                    borderBottom: "1px solid #ccc",
                                    fontWeight: item.isTotalRow
                                      ? "bold"
                                      : "normal",
                                  }}
                                >
                                  <td
                                    style={{
                                      textAlign: "left",
                                      fontWeight: item.isTotalRow
                                        ? "700"
                                        : "normal",
                                    }}
                                  >
                                    {item.circleCode || "-"}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      fontWeight: item.isTotalRow
                                        ? "700"
                                        : "normal",
                                    }}
                                  >
                                    {item.circleName || "-"}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      fontWeight: item.isTotalRow
                                        ? "700"
                                        : "normal",
                                    }}
                                  >
                                    {item.divisionName || "-"}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      fontWeight: item.isTotalRow
                                        ? "700"
                                        : "normal",
                                    }}
                                  >
                                    {item.subDivisionName || "-"}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      fontWeight: item.isTotalRow
                                        ? "700"
                                        : "normal",
                                    }}
                                  >
                                    {role?.employeeDesignationName ||
                                      (item.isTotalRow ? "TOTAL" : "-")}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      fontWeight: item.isTotalRow
                                        ? "700"
                                        : "normal",
                                    }}
                                  >
                                    {item.LoggedInLineStaff || 0}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      fontWeight: item.isTotalRow
                                        ? "700"
                                        : "normal",
                                    }}
                                  >
                                    {item.NeverLoggedInLineStaff || 0}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      fontWeight: item.isTotalRow
                                        ? "700"
                                        : "normal",
                                    }}
                                  >
                                    {item.totalLineStaff || 0}
                                  </td>
                                </tr>
                              );
                            })}

                            {/* 🔹 Grand Total row */}
                            <tr style={{ backgroundColor: "#fef5c0" }}>
                              <td
                                style={{ textAlign: "left", fontWeight: "700" }}
                              >
                                Grand Total
                              </td>
                              <td
                                style={{ textAlign: "left", fontWeight: "700" }}
                              >
                                -
                              </td>
                              <td
                                style={{ textAlign: "left", fontWeight: "700" }}
                              >
                                -
                              </td>
                              <td
                                style={{ textAlign: "left", fontWeight: "700" }}
                              >
                                -
                              </td>
                              <td
                                style={{ textAlign: "left", fontWeight: "700" }}
                              >
                                {[
                                  ...new Set(
                                    tableData
                                      .filter((item) => item.isTotalRow)
                                      .map((item) => {
                                        const role = desginationList.find(
                                          (designation) =>
                                            designation.employeeDesignationId ===
                                            item.roleName
                                        );
                                        return (
                                          role?.employeeDesignationName || "-"
                                        );
                                      })
                                  ),
                                ].join(", ")}
                              </td>
                              <td
                                style={{ textAlign: "left", fontWeight: "700" }}
                              >
                                {tableData
                                  .filter((item) => item.isTotalRow)
                                  .reduce(
                                    (sum, item) =>
                                      sum + (item.LoggedInLineStaff || 0),
                                    0
                                  )}
                              </td>
                              <td
                                style={{ textAlign: "left", fontWeight: "700" }}
                              >
                                {tableData
                                  .filter((item) => item.isTotalRow)
                                  .reduce(
                                    (sum, item) =>
                                      sum + (item.NeverLoggedInLineStaff || 0),
                                    0
                                  )}
                              </td>
                              <td
                                style={{ textAlign: "left", fontWeight: "700" }}
                              >
                                {tableData
                                  .filter((item) => item.isTotalRow)
                                  .reduce(
                                    (sum, item) =>
                                      sum + (item.totalLineStaff || 0),
                                    0
                                  )}
                              </td>
                            </tr>
                          </>
                        ) : (
                          <tr>
                            <td
                              colSpan="8"
                              style={{
                                textAlign: "center",
                                padding: "10px",
                                fontWeight: "bold",
                                color: "red",
                              }}
                            >
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Box>
      {selectedRemarks && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          disableRestoreFocus
        >
          <div style={{ padding: "10px" }}>
            <Typography variant="h6" sx={{ fontSize: "17px" }}>
              Remarks :
            </Typography>
            <Typography sx={{ fontSize: "14px" }}>{selectedRemarks}</Typography>
          </div>
        </Popover>
      )}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default LinemanAPPUserSummary;
